import {Scatter} from '@crema/modules/thirdParty';
export default Scatter;
